import { createFileRoute } from '@tanstack/react-router'
import { PersonDetailScreen } from '@web/app/features/person'

export const Route = createFileRoute('/_index/documents/persons_/$personId')({
  component: PersonDetailRouteComponent,
})

function PersonDetailRouteComponent() {
  const { personId } = Route.useParams()
  return <PersonDetailScreen personId={personId} />
}
